<script lang="ts">
  import { getContext } from 'svelte';
  import { Heading, Paragraph, Wrapper } from './components';
  import { sendEvent } from './helpers/GoogleAnalytics';
  import type {
    UseFormattedProps,
    Country,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;

  const country = getContext<Country>('country');
  const lpKey = getContext<string>('lpKey');

  function handleAnchorClick(event) {
    sendEvent('CTA click', {
      cta_text: 'Didn’t find the answer you are looking for? Contact Us',
      lpKey: lpKey,
      user_domain: window.location.hostname,
      section_clicked: 'faq',
      country: country,
    });
  }
</script>

<Wrapper style="background:var(--vlt-lp-background);">
  <div
    class="faq-section section-truck-plastic wf-section"
    id={properties?.anchor}
  >
    <div class="div-frame-hold">
      <div class="div-steel-jet">
        <Heading
          type={'h2'}
          css={'margin-top:20px;margin-bottom:10px;color:var(--vlt-lp-text);'}
          >{@html properties.heading}</Heading
        >
        <div class="p-occasionally-represent">
          <Paragraph css={'color:var(--vlt-lp-text);'}
            >{@html properties.text}</Paragraph
          >
        </div>
      </div>
      <div class="div-chemical-ancient">
        {#each properties.questions.items as item, index}
          <div class="div-tea-fix">
            <div class="div-personal-dress">
              <span class="span-spent-construction">?</span>
            </div>
            <div class="div-direct-egg">
              <p class="p-proud-needs">{@html item.question}</p>
              <p class="p-upper-bite">{@html item.answer}</p>
            </div>
          </div>
        {/each}
      </div>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <a
        href="#form"
        class="div-stiff-anybody"
        role="button"
        tabindex="0"
        on:click={handleAnchorClick}
      >
        <div class="div-good-our">
          <p class="p-history-later">
            Didn’t find the answer you are looking for? Contact Us
          </p>
        </div>
      </a>
    </div>
  </div>
</Wrapper>

<style>
  p {
    margin: 0;
  }
  .faq-section {
    padding: 0px 15px;
  }

  .section-truck-plastic {
    background-color: rgba(0, 0, 0, 0);
    font-weight: 400;
    text-decoration: none;
  }

  .div-frame-hold {
    max-width: 64rem;
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    padding-right: 15px;
    font-weight: 400;
    text-decoration: none;
    font-family: var(--text-font-paragraph, 'DM Sans');
    color: var(--text-color, #0e0f11);
  }

  .div-steel-jet {
    max-width: 42rem;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    padding: 0;
    font-weight: 400;
    text-decoration: none;
  }

  .p-occasionally-represent {
    max-width: 36rem;
    color: #111;
    margin-top: 1rem;
    margin-left: auto;
    margin-right: auto;
    padding: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.625;
    text-decoration: none;
  }

  .div-chemical-ancient {
    grid-column-gap: 5rem;
    grid-row-gap: 4rem;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    margin-top: 5rem;
    padding: 0;
    font-weight: 400;
    text-decoration: none;
    display: grid;
  }

  .div-tea-fix {
    align-items: flex-start;
    padding: 0;
    font-weight: 400;
    text-decoration: none;
    display: flex;
  }

  .div-personal-dress {
    width: 2rem;
    height: 2rem;
    background-color: var(--vlt-lp-accent);
    color: var(--vlt-lp-accent-text);
    border-style: solid;
    border-width: 0;
    border-radius: 9999px;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    padding: 0;
    font-weight: 400;
    text-decoration: none;
    display: flex;
  }

  .span-spent-construction {
    padding: 0;
    font-size: 1.125rem;
    font-weight: 600;
    line-height: 1.75rem;
    text-decoration: none;
  }

  .div-direct-egg {
    margin-left: 1rem;
    padding: 0;
    font-weight: 400;
    text-decoration: none;
    color: var(--vlt-lp-text);
  }

  .p-proud-needs {
    padding: 0;
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.75rem;
    text-decoration: none;
    color: var(--vlt-lp-text);
    font-family: var(--vlt-lp-heading-font);
  }

  .p-upper-bite {
    margin-top: 1rem;
    padding: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    text-decoration: none;
    opacity: 0.8;
    color: var(--vlt-lp-text);
    font-family: var(--vlt-lp-paragraph-font);
  }

  .div-stiff-anybody {
    justify-content: center;
    align-items: center;
    margin-top: 5rem;
    padding: 0;
    font-weight: 400;
    text-decoration: none;
    display: flex;
    cursor: pointer;
  }

  .div-good-our {
    text-align: center;
    background-color: var(--vlt-lp-secondary);
    border-style: solid;
    border-width: 0;
    border-radius: 9999px;
    padding: 1rem 2rem;
    font-weight: 400;
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .p-history-later {
    color: var(--vlt-lp-secondary-text);
    margin-bottom: 0;
    padding: 0;
    font-weight: 400;
    text-decoration: none;
    font-family: var(--vlt-lp-heading-font);
  }

  @media screen and (min-width: 768px) {
    .div-frame-hold {
      padding-left: 0;
      padding-right: 0;
    }
  }

  @media screen and (min-width: 1280px) {
    .section-truck-plastic {
      background-color: rgba(0, 0, 0, 0);
    }

    .div-chemical-ancient {
      grid-template-columns: 1fr 1fr;
      margin-top: 5rem;
    }

    .div-stiff-anybody {
      margin-top: 5rem;
    }

    .p-history-later {
      margin-bottom: 0;
    }
  }

  @media screen and (min-width: 1440px) {
    .div-chemical-ancient {
      grid-template-columns: 1fr 1fr;
      margin-top: 5rem;
    }

    .div-stiff-anybody {
      margin-top: 5rem;
    }

    .p-history-later {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 991px) {
    .div-chemical-ancient {
      grid-template-columns: 1fr 1fr;
      margin-top: 5rem;
    }

    .div-stiff-anybody {
      margin-top: 5rem;
    }
  }

  @media screen and (max-width: 767px) {
    .div-chemical-ancient {
      grid-template-columns: 1fr;
      margin-top: 3rem;
    }

    .div-stiff-anybody {
      flex-direction: column;
      margin-top: 3rem;
    }
  }
</style>
